import React from 'react';
import { Compass, CheckCircle, Settings, Info } from 'lucide-react';
import { teltonicaImg, teltonikaInstructionImg } from '../../assets';
import { translations } from '../../utils/constants';
const TeltonikaInstruction = ({ language }) => {

    return (
        <div className="container">
            <header className="header">
                <h1 className="title">{translations[language]?.teltonikaInstructionHeading}</h1>
                <p className="subtitle">{translations[language]?.teltonikaInstructionDescription}</p>
            </header>

            <main className="content">
                <section className="section">
                    <div className="section-header">
                        <Compass className="section-icon" />
                        <h2>{translations[language]?.overviewHeading}</h2>
                    </div>
                    <div className="section-content">
                        <p>{translations[language]?.overviewText}</p>
                    </div>
                </section>

                <section className="section">
                    <div className="section-header">
                        <CheckCircle className="section-icon" />
                        <h2>{translations[language]?.prerequisitesHeading}</h2>
                    </div>
                    <div className="section-content">
                        <p>{translations[language]?.prerequisitesText}</p>

                        <div className="server-details">
                            <div className="detail-group">
                                <span className="detail-label">{translations[language]?.serverAddress}</span>
                                <code className="detail-value">34.154.95.179</code>
                            </div>
                            <div className="detail-group">
                                <span className="detail-label">{translations[language]?.port}</span>
                                <code className="detail-value">8081</code>
                            </div>
                            <div className="detail-group">
                                <span className="detail-label">{translations[language]?.protocol}</span>
                                <code className="detail-value">TCP or UDP</code>
                            </div>
                            <div className="detail-group">
                                <span className="detail-label">{translations[language]?.prefix}</span>
                                <code className="detail-value">serial</code>
                            </div>
                        </div>

                        <div className="requirements">
                            <p>{translations[language]?.additionalConfirmText}</p>
                            <ul>
                                <li>{translations[language]?.additionalConfirmList1}</li>
                                <li>{translations[language]?.additionalConfirmList2}</li>
                            </ul>
                        </div>
                    </div>
                </section>

                <section className="section">
                    <div className="section-header">
                        <Settings className="section-icon" />
                        <h2>{translations[language]?.configurationHeading}</h2>
                    </div>
                    <div className="section-content">
                        <div className="config-step">
                            <h3>{translations[language]?.accessRouterInterface}</h3>
                            <p>{translations[language]?.accessRouterInterfaceText}</p>
                        </div>

                        <div className="config-step">
                            <h3>{translations[language]?.navigateToSettings}</h3>
                            <p>{translations[language]?.navigateToSettingsText}</p>
                            <div className="nav-path">
                                <span>{translations[language]?.navServices}</span>
                                <span className="path-separator">→</span>
                                <span>{translations[language]?.navGPS}</span>
                                <span className="path-separator">→</span>
                                <span>{translations[language]?.navNMEA}</span>
                                <span className="path-separator">→</span>
                                <span>{translations[language]?.navForwarding}</span>
                            </div>
                        </div>

                        <div className="ui-example">
                            <img src={teltonicaImg} alt="Teltonika UI Reference" className="ui-image" />
                        </div>

                        <div className="config-step enable-config">
                            <h3>{translations[language]?.enableForwarding}</h3>
                            <p>{translations[language]?.enableForwardingText1}</p>
                            <p className="mt-2">
                                {translations[language]?.enableForwardingText2}{' '}
                            </p>
                            <p className="mt-2">{translations[language]?.enableForwardingText3}</p>

                            <div className="server-details">
                                <div className="detail-group">
                                    <span className="detail-label">{translations[language]?.hostName}</span>
                                    <code className="detail-value">34.154.95.179</code>
                                </div>
                                <div className="detail-group">
                                    <span className="detail-label">{translations[language]?.port}</span>
                                    <code className="detail-value">8081</code>
                                </div>
                                <div className="detail-group">
                                    <span className="detail-label">{translations[language]?.protocol}</span>
                                    <code className="detail-value">TCP or UDP</code>
                                </div>
                                <div className="detail-group">
                                    <span className="detail-label">{translations[language]?.containConnection}</span>
                                    <code className="detail-value">{translations[language]?.containConnectionValue}</code>
                                </div>
                                <div className="detail-group">
                                    <span className="detail-label">{translations[language]?.prefix}</span>
                                    <code className="detail-value">serial</code>
                                </div>
                            </div>
                        </div>

                        <div className="config-step">
                            <h3>{translations[language]?.saveAndVerify}</h3>
                            <p>{translations[language]?.saveAndVerifyText}</p>
                        </div>

                        <div className="ui-example">
                            <div className="section-header">
                                <CheckCircle className="section-icon" />
                                <h2>{translations[language]?.exampleUIReference}</h2>
                            </div>
                            <img src={teltonikaInstructionImg} alt="Teltonika UI Reference" className="ui-image" />
                        </div>
                    </div>
                </section>

                <section className="section">
                    <div className="section-header">
                        <Info className="section-icon" />
                        <h2>{translations[language]?.importantNotesHeading}</h2>
                    </div>
                    <div className="section-content">
                        <div className="note-item">
                            <strong>{translations[language]?.protocolSelectionNote.split(':')[0]}:</strong>{' '}
                            {translations[language]?.protocolSelectionNote.split(':').slice(1).join(':')}
                        </div>

                        <div className="note-item">
                            <strong>{translations[language]?.firewallConsiderationsNote.split(':')[0]}:</strong>{' '}
                            {translations[language]?.firewallConsiderationsNote.split(':').slice(1).join(':')}
                        </div>

                        <div className="note-item">
                            <strong>{translations[language]?.multipleDestinationsNote.split(':')[0]}:</strong>{' '}
                            {translations[language]?.multipleDestinationsNote.split(':').slice(1).join(':')}
                        </div>
                    </div>
                </section>
            </main>
        </div>

    );
};

export default TeltonikaInstruction;
